//@author: devin

import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    NgZone,
    OnChanges,
    OnInit,
    Renderer2,
    SimpleChanges,
    ViewEncapsulation,
} from "@angular/core";
import { S25EditableAbstract } from "../s25.editable.abstract";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
@TypeManagerDecorator("s25-ng-editable-textarea")
@Component({
    selector: "s25-ng-editable-textarea",
    template: `
        @if (this.readOnly) {
            <span class="s25-data" [innerHTML]="convertNewlinesToBr(val)" [class.fade-preview]="fadePreview"></span>
        }

        @if (!this.readOnly) {
            <div>
                @if (!this.editing) {
                    <div
                        class="s25-editable-shared-container c-editable-text editable editable-click"
                        [class.fade-preview]="fadePreview"
                        tabindex="0"
                        (click)="this.editMode()"
                        (keyup.enter)="this.editMode()"
                        (keyup.space)="this.editMode()"
                    >
                        <div class="s25-editable s25-data" [innerText]="val || placeholder || ''"></div>
                    </div>
                }
                @if (this.editing) {
                    <div>
                        <textarea
                            class="firstFocusEditable"
                            [minlength]="this.min"
                            [maxlength]="this.max"
                            [disabled]="this.disabled"
                            [ngModel]="this.candidateVal"
                            [rows]="this.rows"
                            [cols]="this.cols"
                            (ngModelChange)="this.update($event)"
                            (blur)="this.onInputBlur()"
                            id="{{ fieldId ?? '' }}"
                        ></textarea>
                        <div class="aw-button-group">
                            @if (this.hasCancelButton) {
                                <button
                                    class="aw-button aw-button--outline"
                                    (click)="this.cancel()"
                                    (keyup.enter)="this.cancel()"
                                >
                                    {{ this.cancelButtonText }}
                                </button>
                            }
                            @if (this.hasCommitButton) {
                                <button
                                    class="aw-button aw-button--primary"
                                    (click)="this.commit()"
                                    (keyup.enter)="this.commit()"
                                >
                                    {{ this.commitButtonText }}
                                </button>
                            }
                        </div>
                        @if (this.errorMessages) {
                            <div>
                                @for (msg of this.errorMessages; track msg) {
                                    <div class="ngRed ngBold">
                                        {{ msg }}
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        }
    `,
    styles: `
        .s25-data {
            display: block;
            overflow-wrap: break-word;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25EditableTextareaComponent extends S25EditableAbstract<string> implements OnInit, OnChanges {
    getType = () => "textarea";

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
        private zone: NgZone,
        private renderer: Renderer2,
        private sanitizer: DomSanitizer,
    ) {
        super(elementRef, cd, zone, renderer);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["val"]) {
            this.candidateVal = this.val;
            this.cd.markForCheck();
        }
    }

    ngOnInit() {
        super.ngOnInit();
    }

    convertNewlinesToBr(text: any): SafeHtml {
        if (text === null || text === undefined) return "";
        const html = String(text).replace(/\n/g, "<br/>");
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
